import { VendorRebateCategoryRebates } from '../../../components/Vendor/RebateCategoryRebates';

export function RebateCategoryRebates() {
  return <VendorRebateCategoryRebates />;
}
